import React from 'react';
import { useStoreMap } from 'effector-react';
import classNames from 'classnames';
import { type GeneralID, ImageType, type SceneData } from '@types';
import { $sceneMap } from '@stores/dataStores';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import TypeMark from './TypeMark';

interface Props {
  id: GeneralID;
  onDelete: (id: GeneralID) => void;
}

export const BatchSceneListItem = React.memo(({ id, onDelete }: Props) => {
  const data = useStoreMap({
    store: $sceneMap,
    keys: [id],
    fn: (state, [_id]) => state.get(_id) || ({} as SceneData),
  });
  const { thumbUrl } = data;
  return (
    <div style={{ width: 63, height: 63 }} className="relative mb-10">
      <Image
        className={classNames('h-full w-full rounded')}
        src={thumbUrl}
        type={ImageType.thumb}
        size={80}
      />
      <TypeMark type={data.type} />
      <div
        className="hover:bg-opacity-1000 absolute top-5 right-5 flex items-center justify-center bg-black-black bg-opacity-50 hover:bg-blue"
        onClick={() => onDelete(id)}
      >
        <IconTrash active />
      </div>
    </div>
  );
});
